export default {
    name: "infos-personnels-tab-content",
    components: {},
    props: {
        patient: Object,
        info_personne_a_prevenir: Object
    },
    data() {
        return {
            can_see_assure: false,
        };
    },
    computed: {
        info_assure_principal() {
            return this.$store.getters["info_assure_principal"];
        },
    },
    mounted() {
        this.$store.dispatch("getInfoAssurePrincipal", this.$route.params.id).then(() => {
            if (this.info_assure_principal.length == 0) {
                this.can_see_assure = false;
            } else {
                this.can_see_assure = true;
            }
        });
    },
    methods: {
        convertDateToDdMmY(date) {
            let d = new Date(date);

            return d.toLocaleDateString();
        },
    },
};